import React, { Fragment } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { numberTranslate } from 'utils';
import { strings } from 'config';

const engMonthToNepali = month => {
  switch (month) {
    case 'January':
      return 'जनवरी ';
    case 'February':
      return 'फेब्रुअरी ';
    case 'March':
      return 'मार्च';
    case 'April':
      return 'अप्रिल';
    case 'May':
      return 'मेए';
    case 'June':
      return 'जुन';
    case 'July':
      return 'जुलाई ';
    case 'August':
      return 'अगस्त ';
    case 'September':
      return 'सेप्टेम्बर';
    case 'October':
      return 'अक्टोबर';
    case 'November':
      return 'नोवेम्बर';
    case 'December':
      return 'डिसेम्बर';
    default:
      return '';
  }
};

const convertDate = date => {
  let year = numberTranslate(date.split(',')[1]);
  let monthDay = date.split(',')[0].split(' ');
  let month = engMonthToNepali(monthDay[1]);
  let day = numberTranslate(parseInt(monthDay));
  return month + ' ' + day + ',' + year;
};

const TimeStamp = ({ date, className }) => {
  const selectedLang = strings.getLanguage();

  const formattedData = moment(new Date(date).toLocaleDateString('en')).format('Do MMMM, YYYY');
  const resultDate = selectedLang === 'en' ? formattedData : convertDate(formattedData);

  return (
    <Content className={`timestamp ${className}`}>
      {selectedLang === 'en' ? (
        <Fragment>Uploaded on {resultDate}</Fragment>
      ) : (
        <Fragment>{resultDate} मा अपलाेड गरिएकाे</Fragment>
      )}
    </Content>
  );
};

export default TimeStamp;

const Content = styled.span`
  color: rgba(74, 74, 74, 0.5);

  &.detail-block {
    color: #4a4a4a;
    font-size: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/timstamp/timestamp.js